import { Field, Form } from '../../../../utils/forms/form';
import { PropertyType, PropertyDivision, PropertyCategory } from '../../../../../types';
import { PropertyInfo, ComOperationalHoursOther } from '../../../../../constants';
import { validationEmpty } from '../../../../core/empty';

export const DesignationOtherValidator = (field: Field, form: Form) => {
  if (form.fields.designation.value === 10) {
    if (!form.fields.designationOther.value) {
      form.isValid = field.isValid = false;
      return false;
    }
  }
}

export const SpecificPropertiesValidator = (field: Field, form: Form) => {
  const selectedProperties = form.fields.selectedProperties.value;

  if (form.fields.hasSpecificProperties.value) {
    if (!selectedProperties || selectedProperties.length === 0) {
      form.isValid = field.isValid = false;
      return false;
    }
  }
}

export const FtfRequiredFieldValidator = (field: Field, form: Form) => {
  if (!form.fields.hasSpecificProperties.value) {
    const value = field.value;
    if (validationEmpty(value)) {
      form.isValid = field.isValid = false;
      return false;
    }
  }
}

export const FloorAreaValidator = (field: Field, form: Form) => {
  const inFtfMode = !form.fields.hasSpecificProperties.value;
  const hasFloor = PropertyInfo.requiresFloorArea.includes(form.fields.type.value);

  if (inFtfMode && hasFloor) {
    if (validationEmpty(field.value)) {
      form.isValid = field.isValid = false;
      return false;
    }
  }
}

export const LotAreaValidator = (field: Field, form: Form) => {
  const inFtfMode = !form.fields.hasSpecificProperties.value;
  const hasLot = PropertyInfo.requiresLotArea.includes(form.fields.type.value);

  if (inFtfMode && hasLot) {
    if (validationEmpty(field.value)) {
      form.isValid = field.isValid = false;
      return false;
    }
  }
}

export const ResidentialNonLotValidator = (field: Field, form: Form) => {
  const inFtfMode = !form.fields.hasSpecificProperties.value;
  const type = form.fields.type.value as PropertyType;
  const needsFurnishing = type === 'Condominium' || type === 'House and Lot';

  if (inFtfMode && needsFurnishing) {
    if (validationEmpty(field.value)) {
      form.isValid = field.isValid = false;
      return false;
    }
  }
}

export const CommercialRequiredFieldValidator = (field: Field, form: Form) => {
  const division = form.fields.division.value as PropertyDivision;

  if (division === 'Commercial') {
    if (validationEmpty(field.value)) {
      form.isValid = field.isValid = false;
      return false;
    }
  }
}

export const RentalRequiredFieldValidator = (field: Field, form: Form) => {
  const category = form.fields.category.value as PropertyCategory;

  if (category === 'Rent') {
    if (validationEmpty(field.value)) {
      form.isValid = field.isValid = false;
      return false;
    }
  }
}

export const ExistingBusinessRequiredFieldValidator = (field: Field, form: Form) => {
  const status = form.fields.businessStatus.value;

  if (status === 1) {
    if (validationEmpty(field.value)) {
      form.isValid = field.isValid = false;
      return false;
    }
  }
}

export const OperationalOtherValidator = (field: Field, form: Form) => {
  const operationalOthers = form.fields.operationalOthers.value;
  if (operationalOthers === ComOperationalHoursOther.value) {
    if (validationEmpty(field.value)) {
      form.isValid = field.isValid = false;
      return false;
    }
  }
}
